/**
 *
 * SurveyBox
 *
 */

import React from "react"
import "./index.less"

import { Menu, Dropdown, Tag } from "antd"
import alertSvg from "../../images/alert.svg"
import ModalCustom from "../ModalCustom"
import {
  EyeFilled,
  EditFilled,
  CopyFilled,
  DeleteFilled,
} from "@ant-design/icons"
import { isModuleBySlug } from "../../utils/storage"
import { SEGMENTS } from "../../utils/constants"
import { buttonAction_btns, buttonAction_context } from "../Snowplow/config2"

class SurveyBox extends React.Component {
  state = {
    modalDeleteSurvey: false,
    showLoading: false,
  }

  render() {
    const isSegmentsEnabled = isModuleBySlug(SEGMENTS);
    const newSegmentsSet = this.props.survey.segments ? this.props.survey.segments.filter(
      (segment, index, self) =>
        index === self.findIndex((t) => t.id_segment === segment.id_segment)
    ) : [];
    const menu = (
      <Menu>
        <Menu.Item
          disabled={this.props.questions === 0}
          onClick={() => {
            window.open(
              `${process.env.QUESTIONNAIRE_URL}surveys/answers/${this.props.idSurvey}`,
              "_blank"
            )
          }}>
          <EyeFilled style={{ verticalAlign: "middle" }} /> Previsualizar
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            buttonAction_context("Editar medicion",'id_survey',this.props.idSurvey)
            this.props.history.push(`surveys/${this.props.idSurvey}`)
          }}>
          <EditFilled style={{ verticalAlign: "middle" }} /> Editar
        </Menu.Item>
        <Menu.Item
          onClick={() =>
            this.props.duplicateSurveyWatcher(
              this.props.idSurvey,
              this.props.name
            )
          }>
          <CopyFilled style={{ verticalAlign: "middle" }} /> Duplicar
        </Menu.Item>
        <Menu.Item
          style={{ color: "#E37879" }}
          disabled={!this.props.isDeletable}
          onClick={() => this.setState({ modalDeleteSurvey: true })}>
          <DeleteFilled style={{ verticalAlign: "middle" }} /> Eliminar
        </Menu.Item>
      </Menu>
    )

    return (
      <div
        className="survey-box"
        style={{
          backgroundImage: `url(${this.props.backgroundImage})`,
          color: this.props.backgroundImage ? "#FFF" : "",
          cursor: "pointer",
        }}>
        <div
          onClick={() =>
            this.props.history.push(`surveys/${this.props.idSurvey}`)
          }
          style={{ height: "100%" }}>
          {this.props.companyLogo && (
            <img src={this.props.companyLogo} style={{ maxWidth: 40 }} />
          )}
          <div className="survey-box-title">{this.props.name}</div>
          <span
            className="survey-box-questions"
            style={{ color: this.props.backgroundImage ? "#FFF" : "" }}>
            {this.props.questions}{" "}
            {this.props.questions == 1 ? "pregunta" : "preguntas"}
          </span>
        </div>
        <div className="survey-box-footer">
          {isSegmentsEnabled &&
            (this.props.survey.id_scope_type === 1 ? (
              <Tag style={{ fontSize: "13px" }}>Toda la organización</Tag>
            ) : newSegmentsSet.length > 1 ? (
              <Tag
                style={{
                  fontSize: "13px",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}>{`${newSegmentsSet.length} segmentos`}</Tag>
            ) : (
              <Tag
                style={{
                  fontSize: "13px",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}>
                {newSegmentsSet[0].name}
              </Tag>
            ))}
          <Dropdown overlay={menu}>
            <div className="dots">
              <span
                className="dot"
                style={{
                  backgroundColor: this.props.companyLogo ? "white" : "",
                }}
              />
              <span
                className="dot"
                style={{
                  backgroundColor: this.props.companyLogo ? "white" : "",
                }}
              />
              <span
                className="dot"
                style={{
                  backgroundColor: this.props.companyLogo ? "white" : "",
                }}
              />
            </div>
          </Dropdown>
        </div>

        <ModalCustom
          isLoadingButton={this.state.showLoading}
          modalOpen={this.state.modalDeleteSurvey}
          showFooter
          onOk={() => {
            this.setState({
              showLoading: true,
              modalDeleteSurvey: false,
            })
            setTimeout(() => {
              this.setState({ showLoading: false })
            }, 1000)
            this.props.deleteSurveyWatcher(this.props.idSurvey)
          }}
          onCancel={() => this.setState({ modalDeleteSurvey: false })}
          textButton="Eliminar">
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            ¿Estás seguro de que deseas eliminar el cuestionario?
          </span>
        </ModalCustom>
      </div>
    )
  }
}

SurveyBox.propTypes = {}

export default SurveyBox
